import { createRoot } from "react-dom/client";
import { HelmetProvider } from "react-helmet-async";
import { CANONICAL_ORIGIN } from "@/lib/canonical";
import App from "./App.tsx";
import "./index.css";

// Domain redirects are handled by hosting. Avoid client-side redirects here to prevent reload loops.

createRoot(document.getElementById("root")!).render(
  <HelmetProvider>
    <App />
  </HelmetProvider>
);
